import { Routes } from "@angular/router";

export const AdminLayoutRoutes: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("../../features/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "identification",
    loadChildren: () =>
      import("../../features/identification/identification.module").then(
        (m) => m.IdentificationModule
      ),
  },
  {
    path: "verification-customer",
    loadChildren: () =>
      import("../../features/verification-customer/verification-customer.module").then(
        (m) => m.VerificationCustomerModule
      ),
  },
  {
    path: "contracts",
    loadChildren: () =>
      import("../../features/contracts/contracts.module").then(
        (m) => m.ContractsModule
      ),
  },
  {
    path: "services",
    loadChildren: () =>
      import("../../features/services/services.module").then(
        (m) => m.ServicesModule
      ),
  },

  {
    path: "deposit-request",
    loadChildren: () =>
      import("../../features/request-rial/request-rial.module").then(
        (m) => m.RequestRialModule
      ),
  },
  {
    path: "withdraw-request",
    loadChildren: () =>
      import("../../features/withdraw/withdraw.module").then(
        (m) => m.WithdrawModule
      ),
  },
  {
    path: "verification-bank",
    loadChildren: () =>
      import("../../features/verification-bank/verification-bank.module").then(
        (m) => m.VerificationBankModule
      ),
  },
  {
    path: "verification-marketer",
    loadChildren: () =>
      import("../../features/verification-marketer/verification-marketer.module").then(
        (m) => m.VerificationMarketerModule
      ),
  },
  {
    path: "affiliate-marketing",
    loadChildren: () =>
      import("../../features/affiliate-marketing/affiliate-marketing.module").then(
        (m) => m.AffiliateMarketingModule
      ),
  },
  {
    path: "all-users",
    loadChildren: () =>
      import("../../features/all-users/all-users.module").then(
        (m) => m.AllUsersModule
      ),
  },

  {
    path: "quote-request",
    loadChildren: () =>
      import("../../features/quote-request/quote-request.module").then(
        (m) => m.QuoteRequestModule
      ),
  },
  {
    path: "request-list-customer",
    loadChildren: () =>
      import("../../features/request-list/request-list.module").then(
        (m) => m.RequestListModule
      ),
  },
  {
    path: "response-list/:id",
    loadChildren: () =>
      import("../../features/response-list/response-list.module").then(
        (m) => m.ResponseListModule
      ),
  },
  {
    path: "valid-time-setting",
    loadChildren: () =>
      import("../../features/valid-time-setting/valid-time-setting.module").then(
        (m) => m.ValidTimeSettingModule
      ),
  },
];
